import * as React from 'react';
import { PdsIconFile as PdsIconFileElement } from '@principal/design-system-icons-web';
import {
  IconSize,
  ValidIconColor,
} from '../../../utils/icon-utilities';
import { createPdsReactComponent } from '../../../../../react/src/lib/create-pds-react-component';

interface IconProps {
  size?: IconSize;
  color?: ValidIconColor;
}

export const PdsIconFile = createPdsReactComponent<IconProps>()({
  tagName: 'pds-icon-file',
  elementClass: PdsIconFileElement,
  react: React,
});
